import { useMsal } from "@azure/msal-react";
import { useCallback, useEffect } from "react";
import { getApiAccessToken } from "../../utils/headers";

const TOKEN_REFRESH_INTERVAL = 1_800_000; // 30 minutes in milliseconds

const TokenRefresh = () => {
  const { instance, accounts } = useMsal();

  const refreshToken = useCallback(async () => {
    if (accounts.length === 0) {
      return;
    }

    try {
      console.log("Attempting token refresh...");
      await getApiAccessToken(instance, accounts[0], true);
    } catch (error) {
      console.error("Token refresh failed:", error);
    }
  }, [accounts, instance]);

  useEffect(() => {
    if (instance && accounts.length > 0) {
      refreshToken();
      const intervalId = setInterval(refreshToken, TOKEN_REFRESH_INTERVAL);
      return () => {
        clearInterval(intervalId);
      };
    }
  }, [instance, accounts, refreshToken]);

  return null;
};

export default TokenRefresh;
